import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const scheduleAPI = {
  getSchoolPeriods: async () => {
    const response = await apiClient.get("/teacher/school-periods");
    return unwrapApiResponse(response);
  },

  getCalendar: async () => {
    const response = await apiClient.get("/teacher/calendar");
    return unwrapApiResponse(response);
  },

  getWeeklySchedule: async () => {
    const response = await apiClient.get("/teacher/weekly-schedule");
    return unwrapApiResponse(response);
  },
};
